//@flow
import { isValidDate,isValidMonthYearDate } from '@lesofi/phoenix-sdk-js/lib/util/dateUtil';
import * as inputValidate from '@lesofi/phoenix-sdk-js/lib/util/inputValidate'
import {YES,NO} from '../../Utils/variables'
import collect from 'collect.js'
import * as actionTypes from '../../redux/kratos/actionTypes'

import type { DataFormContainer$Props } from './flowTypes'
import type { Collection } from 'collect.js'

const validateUnitInfoDates = [
    'unit1MoveinDate',
    'unit1LastIncreaseDate',
    'unit2MoveinDate',
    'unit2LastIncreaseDate',
    'unit3MoveinDate',
    'unit3LastIncreaseDate',
    'unit4MoveinDate',
    'unit4LastIncreaseDate',
    'unit5MoveinDate',
    'unit5LastIncreaseDate'
]

const numbersDashesFieldsByFormTypes = [
    {formType: 'ec', fields: ['houseId1','unitId1','houseId2','unitId2','houseId3','unitId3','apt']},
    {formType: 'rr', fields: ['emergencyPhone','registrantPhone']},
    {formType: 'rrb', fields: ['emergencyPhone','registrantPhone']}
]

const numbersWithCommasFields = [
    'phone'
]

const numbersWithSpaceAndSlashFields = [
    'unit1BedroomCount',
    'unit2BedroomCount',
    'unit3BedroomCount',
    'unit4BedroomCount',
    'unit5BedroomCount'
]

const validateSpecialCharactersForRRUFields = [
    'unit1UnitNumber',
    'unit2UnitNumber',
    'unit3UnitNumber',
    'unit4UnitNumber',
    'unit5UnitNumber'
]

const validateSingleInputEmailByFormTypes = [
    {formType: 'rr', fields: ['emergencyEmail','registrantEmail']},
    {formType: 'rrb', fields: ['emergencyEmail','registrantEmail']}
]

const validatePhoneInputByFormTypes = [
    {formType: 'rr', fields: ['emergencyPhone','registrantPhone']},
    {formType: 'rrb', fields: ['emergencyPhone','registrantPhone']}
]

const validateZipCodeInputByFormTypes = [
    {formType: 'ec', fields: ['zipCode']},
    {formType: 'rr', fields: ['emergencyZipCode']},
    {formType: 'rrb', fields: ['propZipCode','emergencyZipCode']}
]

const validatePhoneExtInputByFormTypes = [
    {formType: 'ec', fields: ['phoneExt']}
]

export const validate = (values:any,props:DataFormContainer$Props) => {
    const { kratos } = props;
    const errors = {};

    let requiredFields = [
        'formType',
        'formServiceYear'
    ];

    if (props.formType == 'ec'){
        requiredFields.push('noChanges')
        requiredFields.push('renewIndicator')
        requiredFields.push('renewUnitIndicator')
        requiredFields.push('newExemptionIndicator')
        requiredFields.push('signatureIndicator')
    }
    
    if (props.formType == 'rr'){
        requiredFields.push('sameInfoCheck')
    }

    //Applicable to all forms
    propertyInfoFormFields.forEach(field => {
        if ((field == 'apn' && !values.isApnNotFound) || (field == 'statementNo' && !values.isStatementNotFound)){
            requiredFields.push(field)
        }
    })

    if (props.formType == 'rru') {
        requiredFields = requiredFields.filter(v=> v !== 'statementNo' )
        unitInfo1Fields.forEach(field => {
            requiredFields.push(field)
        })
        
        unitInfo2Fields.forEach(field => {
            requiredFields.push(field)
        })

        unitInfo3Fields.forEach(field => {
            requiredFields.push(field)
        })

        unitInfo4Fields.forEach(field => {
            requiredFields.push(field)
        })

        unitInfo5Fields.forEach(field => {
            requiredFields.push(field)
        })
    }

    //Exception Form Type require fields
    if (props.formType == 'exc') {
        requiredFields = requiredFields.filter(v=> v !== 'formServiceYear' )
        requiredFields = requiredFields.filter(v=> v !== 'statementNo' )
        exceptionFormFields.forEach(field => {
            requiredFields.push(field)
        })
    }
    
    if (!values.isInvalidDoc){
        requiredFields.forEach(field => {
            if (!values[field]) {
                errors[field] = 'Required'
            }
        })
    }  
    //Validate Invoice Date
    if (values.signatureDate && !isValidDate(values.signatureDate)){
        errors.signatureDate = 'Invalid date format for this pattern mm/dd/yyyy'
    }

    if (values.formType && values.formType=='rru'){
        validateUnitInfoDates.forEach(dateField => {
            if (values[dateField] && !isValidMonthYearDate(values[dateField])) {
                errors[dateField] = 'Invalid date format for this pattern mm/yyyy'
            }
        })
    }
    
    if (values.apn){
        if (values.apn.length < 10){
            errors.apn = '10 digits is required'
        }else if (values.apn.length > 10) {
            errors.apn = 'Invalid and only 10 digits is allowed'
        }
    }

    if (values.statementNo){
        if (values.statementNo.length < 7){
            errors.statementNo = '7 digits is required'
        }else if (values.statementNo.length > 7){
            errors.statementNo = 'Invalid and only 7 digits is allowed'
        }
    }
    
    //Numbers and Dashes Fields Validation
    numbersDashesFieldsByFormTypes.forEach(item => {
        if (props.formType == item['formType']) {
            item['fields'].forEach(field => {
                if (values[field]) {
                    if (!inputValidate.isValidNumberAndDash(values[field])){
                        errors[field] = 'Invalid format. Only numbers/dashes is allow'
                    }
                }
            })
        }
    })

    validateSingleInputEmailByFormTypes.forEach(item => {
        if (props.formType == item['formType']) {
            item['fields'].forEach(field => {
                if (values[field]){
                    if (!inputValidate.isValidEmail(values[field])){
                        errors[field] = 'Invalid email address'
                    }
                }
            })
        }
    })

    validatePhoneInputByFormTypes.forEach(item => {
        if (props.formType == item['formType']) {
            item['fields'].forEach(field => {
                if (values[field]){
                    if (values[field].length < 10){
                        errors[field] = '10 digits is required'
                    }else if (values[field].length > 10){
                        errors[field] = 'Invalid and only 10 digits is allow'
                    } 
                }
            })
        }
    })

    validateZipCodeInputByFormTypes.forEach(item => {
        if (props.formType == item['formType']) {
            item['fields'].forEach(field => {
                if (values[field]){
                    if (values[field].length < 5){
                        errors[field] = '5 digits is required'
                    }else if (values[field].length > 5){
                        errors[field] = 'Invalid and only 5 digits is allow'
                    } 
                }
            })
        }
    })

    validatePhoneExtInputByFormTypes.forEach(item => {
        if (props.formType == item['formType']) {
            item['fields'].forEach(field => {
                if (values[field]){
                    if (values[field].length > 8){
                        errors[field] = 'Invalid only 8 digits is allowed'
                    } 
                }
            })
        }
    })
    
    //Numbers and allow comma fields validation
    if (props.formType == 'ec'){
        numbersWithCommasFields.forEach(field => {
            if (values[field]){
                if (!inputValidate.isValidNumberAndComa(values[field])){
                    errors[field] = 'Invalid format. Only numbers and comma(1234,5677) is allow'
                }
                const numbers = values[field].split(",")
                numbers.forEach(phoneNo => {
                    if (phoneNo.length < 10){
                        errors[field] = '10 digits is required'
                    }else if (phoneNo.length > 10){
                        errors[field] = 'Invalid and only 10 digits is allow'
                    } 
                })
            }
        })
    }
    
    if (props.formType == 'rru'){
        numbersWithSpaceAndSlashFields.forEach(field => {
            if (values[field]){
                if (!inputValidate.isValidNumberAndSpaceSlash(values[field])){
                    errors[field] = 'Invalid format. Only numbers, space/bask slash is allow'
                }
            }
        })

        validateSpecialCharactersForRRUFields.forEach(field => {
            if (values[field]) {
                if (!inputValidate.hasAnySpecialCharacters(values[field])) {
                    errors[field] = 'Special characters not allow. Only aphabets and numbers are allow'
                }
            }
        })
    }

    validateQualityReviewQuestions(values,errors,props)

    const updateFormError = (props.updateFormError:any)
    updateFormError(errors);

    return errors;
}

const validateQualityReviewQuestions=(values:any,errors:any,props:DataFormContainer$Props)=>{
    const kratos = (props.kratos:any)
    const reviewQuestions = (kratos.reviewQuestions:any)

    const questions = reviewQuestions.filter(question=> question.mandatory == true)
    questions.map(question=>{
        if (question.questionType == 'singleSelect'){
            if (!values[question.elementId]){
                errors[question.elementId] = 'This field is required!'
            }
        }else if (question.questionType == 'yesNo'){
            const yesElement = `${question.elementId}_${YES}`
            const noElement = `${question.elementId}_${NO}`

            if (!values[yesElement] && !values[noElement]){
                errors[yesElement] = 'Please select at least one answer.'
                errors[noElement] = 'Please select at least one answer.'
            }else {
                if (values[yesElement]){
                    let anySubAnswers = []
                    question.yesSubAnswers.map(subAnswer=>{
                        if (values[subAnswer.field]){
                            anySubAnswers.push(subAnswer)
                        }
                    })
                    if (anySubAnswers.length == 0){
                        question.yesSubAnswers.map(subAnswer=>{
                            if (!values[subAnswer.field]){
                                errors[subAnswer.field] = 'Please select at least one answer.'
                            }
                        })
                    }
                }
            }
        }
    })
}

export const getQualityReviewFormNoOfError=(props:DataFormContainer$Props,collectErrorFields:Collection<any>)=>{
    let noOfError = 0
    const kratos = (props.kratos:any)
    const reviewQuestions = (kratos.reviewQuestions:any)

    const questions = reviewQuestions.filter(question=> question.mandatory == true)
    questions.map(question=>{
        if (question.questionType == 'singleSelect'){
            if (collectErrorFields.has(question.elementId)){
                noOfError+=1
            }
        }else if (question.questionType == 'yesNo'){
            const yesElement = `${question.elementId}_${YES}`
            const noElement = `${question.elementId}_${NO}`

            if (collectErrorFields.has(yesElement) && collectErrorFields.has(noElement)){
                noOfError+=1
            }else {
                let anySubAnswersError = false
                question.yesSubAnswers.map(subAnswer=>{
                    if (collectErrorFields.has(subAnswer.field)){
                        anySubAnswersError = true
                    }
                })
                if (anySubAnswersError){
                    noOfError+=1
                }    
            }
        }
    })

    return noOfError
}

const formInfoFields = [
    'formType','formServiceYear'
]

const billContactInfoFields = [
    'noChanges'
]

const exemptReqInfoFields = [
    'renewIndicator','renewUnitIndicator','newExemptionIndicator'
]

const signatureInfoFields =[
    'signatureIndicator'
]

const registrantInfoFields = [
    'sameInfoCheck'
]

const unitInfo1Fields = [
    'unit1UtilityPaidByLandlord',
    'unit1IncludeParking',
    'unit1ExemptionType'
]

const unitInfo2Fields = [
    'unit2UtilityPaidByLandlord',
    'unit2IncludeParking',
    'unit2ExemptionType'
]

const unitInfo3Fields = [
    'unit3UtilityPaidByLandlord',
    'unit3IncludeParking',
    'unit3ExemptionType'
]

const unitInfo4Fields = [
    'unit4UtilityPaidByLandlord',
    'unit4IncludeParking',
    'unit4ExemptionType'
]

const unitInfo5Fields = [
    'unit5UtilityPaidByLandlord',
    'unit5IncludeParking',
    'unit5ExemptionType'
]

const exceptionFormFields = [
    'correspondenceType'
]

const propertyInfoFormFields = [
    'apn',
    'statementNo'
]

export const isAnyFormErrors=(formError:any,panel:any,props:DataFormContainer$Props)=>{
    let noOfErrors = 0
    const collectErrorFields =  collect(formError) 
    switch(panel){
        case actionTypes.KRATOS_PANEL_FORM_INFO:
            formInfoFields.forEach(field=> {
                if (collectErrorFields.has(field)){
                    noOfErrors = parseInt(noOfErrors) + 1
                }
            })
            if (parseInt(noOfErrors) > 0){
                return noOfErrors
            }
                
            return null
        
        case actionTypes.KRATOS_PANEL_PROPERTY_INFO: 
            propertyInfoFormFields.forEach(field=> {
                if (collectErrorFields.has(field)){
                    noOfErrors = parseInt(noOfErrors) + 1
                }
            })
            if (parseInt(noOfErrors) > 0){
                return noOfErrors
            }
            
            return null    
        
        case actionTypes.KRATOS_PANEL_EXCEPTION_FORM_INFO:
            exceptionFormFields.forEach(field=> {
                if (collectErrorFields.has(field)){
                    noOfErrors = parseInt(noOfErrors) + 1
                }
            })
            if (parseInt(noOfErrors) > 0){
                return noOfErrors
            }
                
            return null

        case actionTypes.KRATOS_PANEL_BILLCONTACT_INFO:   
            billContactInfoFields.forEach(field=> {
                if (collectErrorFields.has(field)){
                    noOfErrors=parseInt(noOfErrors) + 1
                }
            })
            if (parseInt(noOfErrors) > 0){
                return noOfErrors
            }

            return null
        
        case actionTypes.KRATOS_PANEL_EXEMPTREQ_INFO:
            exemptReqInfoFields.forEach(field=> {
                if (collectErrorFields.has(field)){
                    noOfErrors=parseInt(noOfErrors) + 1
                }
            })
            if (parseInt(noOfErrors) > 0){
                return noOfErrors
            }

            return null
        
        case actionTypes.KRATOS_PANEL_SIGNATURE_INFO:
            signatureInfoFields.forEach(field=> {
                if (collectErrorFields.has(field)){
                    noOfErrors=parseInt(noOfErrors) + 1
                }
            })
            if (parseInt(noOfErrors) > 0){
                return noOfErrors
            }

            return null
        
        case actionTypes.KRATOS_PANEL_REVIEW_QUESTIONS:
            noOfErrors = getQualityReviewFormNoOfError(props,collectErrorFields)

            if (noOfErrors){
                return noOfErrors
            }else {
                return null
            }
        
        case actionTypes.KRATOS_PANEL_REGISTRANT_INFO:
            registrantInfoFields.forEach(field=> {
                if (collectErrorFields.has(field)){
                    noOfErrors=parseInt(noOfErrors) + 1
                }
            })
            if (parseInt(noOfErrors) > 0){
                return noOfErrors
            }

            return null
        
        case actionTypes.KRATOS_PANEL_UNIT_INFO_1:
            unitInfo1Fields.forEach(field=> {
                if (collectErrorFields.has(field)){
                    noOfErrors=parseInt(noOfErrors) + 1
                }
            })    
            if (parseInt(noOfErrors) > 0){
                return noOfErrors
            }

            return null
        
        case actionTypes.KRATOS_PANEL_UNIT_INFO_2:
            unitInfo2Fields.forEach(field=> {
                if (collectErrorFields.has(field)){
                    noOfErrors=parseInt(noOfErrors) + 1
                }
            })    
            if (parseInt(noOfErrors) > 0){
                return noOfErrors
            }

            return null
        
        case actionTypes.KRATOS_PANEL_UNIT_INFO_3:
            unitInfo3Fields.forEach(field=> {
                if (collectErrorFields.has(field)){
                    noOfErrors=parseInt(noOfErrors) + 1
                }
            })    
            if (parseInt(noOfErrors) > 0){
                return noOfErrors
            }

            return null
        
        case actionTypes.KRATOS_PANEL_UNIT_INFO_4:
            unitInfo4Fields.forEach(field=> {
                if (collectErrorFields.has(field)){
                    noOfErrors=parseInt(noOfErrors) + 1
                }
            })    
            if (parseInt(noOfErrors) > 0){
                return noOfErrors
            }

            return null
        
        case actionTypes.KRATOS_PANEL_UNIT_INFO_5:
            unitInfo5Fields.forEach(field=> {
                if (collectErrorFields.has(field)){
                    noOfErrors=parseInt(noOfErrors) + 1
                }
            })    
            if (parseInt(noOfErrors) > 0){
                return noOfErrors
            }

            return null
    }
    return null
}


// WEBPACK FOOTER //
// ./src/views/ProjectKratos/validate.js